export default __webpack_public_path__ + "static/media/emaillogo.3ef7c90b.svg";